import api from '@/services/api';

const ENTITY_ENDPOINT = 'recurso-tipo';

const recurso_tipo_service = {
  /**
   * Obtiene todos los recurso-tipo con parámetros de paginación y filtros
   * @param {string} params - Parámetros de consulta como string
   * @returns {Promise} Respuesta de la API
   */
  async findAll(params = {}) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}`, { params });
      return response;
    } catch (error) {
      console.error('Error al obtener recurso-tipo:', error);
      throw error;
    }
  },

  /**
   * Busca un recurso-tipo por su código
   * @param {string} codigo - Código del recurso-tipo
   * @returns {Promise} Respuesta de la API
   */
  async findByCodigo(codigo) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error al obtener recurso-tipo con codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Busca un recurso-tipo por su clave interna
   * @param {string} claveInterna - Clave interna del recurso-tipo
   * @returns {Promise} Respuesta de la API
   */
  async findByClaveInterna(claveInterna) {
    try {
      const response = await api.get(`/${ENTITY_ENDPOINT}/clave-interna/${claveInterna}`);
      return response;
    } catch (error) {
      console.error(`Error al obtener recurso-tipo con clave interna ${claveInterna}:`, error);
      throw error;
    }
  },

  /**
   * Crea un nuevo recurso-tipo
   * @param {Object} data - Datos del recurso-tipo a crear
   * @returns {Promise} Respuesta de la API
   */
  async create(data) {
    try {
      const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
      const response = await api.post(`/${ENTITY_ENDPOINT}`, data, {
        headers: isForm ? { 'Content-Type': 'multipart/form-data' } : undefined,
      });
      return response;
    } catch (error) {
      console.error('Error creando recurso-tipo:', error);
      throw error;
    }
  },

  /**
   * Actualiza un recurso-tipo existente
   * @param {string} codigo - Código del recurso-tipo a actualizar
   * @param {Object} data - Datos actualizados del recurso-tipo
   * @returns {Promise} Respuesta de la API
   */
  async update(codigo, data) {
    try {
      const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
      const response = await api.patch(`/${ENTITY_ENDPOINT}/${codigo}`, data, {
        headers: isForm ? { 'Content-Type': 'multipart/form-data' } : undefined,
      });
      return response;
    } catch (error) {
      console.error(`Error actualizando recurso-tipo con codigo ${codigo}:`, error);
      throw error;
    }
  },

  /**
   * Elimina un recurso-tipo por su código
   * @param {string} codigo - Código del recurso-tipo a eliminar
   * @returns {Promise} Respuesta de la API
   */
  async delete(codigo) {
    try {
      const response = await api.delete(`/${ENTITY_ENDPOINT}/${codigo}`);
      return response;
    } catch (error) {
      console.error(`Error eliminando recurso-tipo con codigo ${codigo}:`, error);
      throw error;
    }
  },
};

export default recurso_tipo_service;
